import React, { useState, useEffect } from 'react';
import { Popover, Typography, Box, Grid, Avatar, Badge } from '@mui/material';
import styles from "./notification.module.css";
import { useSelector, useDispatch } from "react-redux";
import { setChangeEmail } from "../../store/actions/authActions";
import { REQUESTER_ROLES } from "../../utils/constants/roles";
import CloseIcon from '@mui/icons-material/Close';
import { ReactComponent as Notification } from "../../utils/assets/notification.svg";
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";
import moment from "moment";
import RealTimeNotificationModal from "./realTimeNotification"

export default function NotificationModal({ setOpenAuthentication, setOpenedAccount }) {
    const axios = useAxiosPrivate()
    const dispatch = useDispatch();
    const role = useSelector((state) => state.auth.role);
    const [open, setOpen] = useState(false);
    const [dot, setDot] = useState(false);
    const [notificationData, setNotificationData] = useState([]);
    const [matchNotificationData, setMatchNotificationData] = useState([]);
    const [newNotificationData, setNewNotificationData] = useState([]);
    const [readNotificationData, setReadNotificationData] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorPosition, setAnchorPosition] = useState({ top: 0, left: 0 });
    const profilePic = useSelector((state) => state.auth.url);

    const handleClick = (event) => {
        setAnchorEl(event?.currentTarget ? event?.currentTarget : anchorEl);
        const appBarBottom =
            document
                .querySelector(".MuiAppBar-root")
                ?.getBoundingClientRect().bottom ?? 0;
        setAnchorPosition({ top: appBarBottom, left: window.innerWidth });
        setOpen(true)
        if (matchNotificationData?.length !== notificationData?.length) {
            setDot(false)
            setMatchNotificationData(notificationData)
            setNewNotificationData(notificationData)
        }
        const newNotifi = notificationData.filter(function (o1) {
            // filter out (!) items in result2
            return !matchNotificationData.some(function (o2) {
                return o1.id === o2.id;          // assumes unique id
            });
        })
        const read = notificationData.filter(function (o1) {
            // filter out (!) items in result2
            return matchNotificationData.some(function (o2) {
                return o1.id === o2.id;          // assumes unique id
            });
        })
        setNewNotificationData(newNotifi)
        setReadNotificationData(read)
    }

    const handleClose = () => {
        setOpen(false)
    };

    useEffect(() => {
        loadNotificationData();
        // eslint-disable-next-line
    }, []);

    const loadNotificationData = async (e) => {
        try {
            const { data } = await axios.get("/notifications/list");
            if (matchNotificationData?.length !== data.data?.length) {
                setDot(true)
            }
            setNotificationData(data.data)
        } catch (error) {
            console.log(error);
        }
    };

    const handleVerify = async (e) => {
        try {
            const { data: completeData } = await axios.get(`/actions/complete/${e?.data?.request_id}`);
            await axios.get(`/notifications/mark_as_seen/${e.id}`);
            const emailMatch = completeData?.message?.match(/[\w.+-]+@[\w-]+\.[\w.-]+/);
            const newEmail = emailMatch?.[0] || e?.data?.new_email;
            if (newEmail) {
                dispatch(setChangeEmail(newEmail));
            }
            loadNotificationData();
        } catch (error) {
            console.log(error);
        }
        setOpen(false);
        setAnchorEl(null);
        requestAnimationFrame(() => {
            setOpenAuthentication(true);
        });
    };

    const handleReview = async (e) => {
        try {
            await axios.get(`/notifications/mark_as_seen/${e.id}`);
            setOpenedAccount(true)
            loadNotificationData()
        } catch (error) {
            console.log(error);
        }
        setOpen(false)
    };

    const handleMarkAsSeen = async (e) => {
        try {
            await axios.get(`/notifications/mark_as_seen/${e.id}`);
            const { data } = await axios.get("/notifications/list");
            setOpen(false)
            setNotificationData(data.data)
        } catch (error) {
            console.log(error);
        }
    };

    const id = open ? 'simple-popover' : undefined;

    return (
        <div>
            <Box style={{ margin: "0rem 1.5rem 0rem 1.5rem" }} >
                {dot ?
                    <Badge sx={{
                        "& .MuiBadge-badge": {
                            backgroundColor: 'var(--primary-theme-color)'
                        }
                    }} variant="dot">
                        <Notification aria-describedby={id} onClick={handleClick} />
                    </Badge> :
                    <Badge>
                        <Notification aria-describedby={id} onClick={handleClick} />
                    </Badge>
                }
            </Box>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorReference="anchorPosition"
                anchorPosition={anchorPosition}
                marginThreshold={0}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    style: {
                        backgroundColor: 'var(--primary-popup-background-color)',
                        border: '3px solid var(--primary-popup-stroke-color)',
                        borderRadius: '0px 0px 0px 16px',
                    },
                }}
            >
                <Box className={styles.boxCSS}>
                    <Box className={styles.boxCSS2} style={{ position: "relative" }}>
                        <Typography sx={{ p: 3, fontFamily: "Poppins", fontStyle: "normal", fontWeight: "600", fontSize: "16px", textAlign: "center", color: "var(--primary-text-color)" }} className={styles.notificationHeader}>Notifications: {newNotificationData?.length} new</Typography>
                        <CloseIcon
                            onClick={handleClose}
                            style={{
                                position: "absolute",
                                top: "14px",
                                right: "20px",
                                cursor: "pointer",
                                color: "var(--primary-text-color)",
                            }}
                        />
                    </Box>
                    {newNotificationData.map((item) => (
                        <Box key={item.id} className={styles.boxCSSUnRead}>
                            <Grid container>
                                <Grid item md={10}>
                                    <Grid item md={12}>
                                        <Typography sx={{ p: 1, fontFamily: "Poppins", fontStyle: "normal", fontWeight: "400", fontSize: "12px", color: "var(--primary-text-color)" }} className={styles.notificationDate}>{`${moment(item?.time).format('LT')}  ${moment(item?.time).format('ll')}`}</Typography>
                                    </Grid>
                                    <Grid item md={12}>
                                        <Grid container>
                                            <Grid item md={2} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <Avatar
                                                    alt="Remy Sharp"
                                                    src={profilePic}
                                                    sx={{ width: 35, height: 35 }}
                                                />
                                            </Grid>
                                            <Grid item md={10}>
                                                {REQUESTER_ROLES.includes(role) ?
                                                    <Typography sx={{ p: 2, fontFamily: "Poppins", fontStyle: "normal", fontWeight: "400", fontSize: "13.5px", color: "var(--primary-text-color)" }}>{item?.message}  <span style={{ color: "var(--primary-theme-color)", textDecorationLine: 'underline', cursor: "pointer" }} onClick={() => handleVerify(item)}>{item?.data?.status !== 'DECLINED' ? "Verify Now" : null}</span></Typography>
                                                    : <Typography sx={{ p: 2, fontFamily: "Poppins", fontStyle: "normal", fontWeight: "400", fontSize: "13.5px", color: "var(--primary-text-color)" }}>{item?.message}  <span style={{ color: "var(--primary-theme-color)", textDecorationLine: 'underline', cursor: "pointer" }} onClick={() => handleReview(item)}>Review</span></Typography>
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item md={2} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <CloseIcon style={{ cursor: "pointer", color: "var(--primary-text-color)" }} onClick={() => handleMarkAsSeen(item)} />
                                </Grid>
                            </Grid>
                        </Box>
                    ))}
                    {readNotificationData.map((item) => (
                        <Box key={item.id} className={styles.boxCSSRead}>
                            <Grid container>
                                <Grid item md={10}>
                                    <Grid item md={12}>
                                        <Typography sx={{ p: 1, fontFamily: "Poppins", fontStyle: "normal", fontWeight: "400", fontSize: "12px", color: "var(--primary-text-color)" }} className={styles.notificationDate}>{`${moment(item?.time).format('LT')}  ${moment(item?.time).format('ll')}`}</Typography>
                                    </Grid>
                                    <Grid item md={12}>
                                        <Grid container>
                                            <Grid item md={2} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <Avatar
                                                    alt="Remy Sharp"
                                                    src={profilePic}
                                                    sx={{ width: 35, height: 35 }}
                                                />
                                            </Grid>
                                            <Grid item md={10}>
                                                {REQUESTER_ROLES.includes(role) ?
                                                    <Typography sx={{ p: 2, fontFamily: "Poppins", fontStyle: "normal", fontWeight: "400", fontSize: "13.5px", color: "var(--primary-text-color)" }}>{item?.message}  <span style={{ color: "var(--primary-theme-color)", textDecorationLine: 'underline', cursor: "pointer" }} onClick={() => handleVerify(item)}>{item?.data?.status !== 'DECLINED' ? "Verify Now" : null}</span></Typography>
                                                    : <Typography sx={{ p: 2, fontFamily: "Poppins", fontStyle: "normal", fontWeight: "400", fontSize: "13.5px", color: "var(--primary-text-color)" }}>{item?.message}  <span style={{ color: "var(--primary-theme-color)", textDecorationLine: 'underline', cursor: "pointer" }} onClick={() => handleReview(item)}>Review</span></Typography>
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item md={2} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <CloseIcon style={{ cursor: "pointer", color: "var(--primary-text-color)" }} onClick={() => handleMarkAsSeen(item)} />
                                </Grid>
                            </Grid>
                        </Box>
                    ))}
                </Box>
            </Popover>
            <RealTimeNotificationModal setOpenAuthentication={setOpenAuthentication} setOpenedAccount={setOpenedAccount} setNotificationData={setNotificationData} setDot={setDot} notificationData={notificationData} />
        </div>
    );
}